import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31b36a7c&"
import script from "./zPayCreditCard.js?vue&type=script&lang=js&"
export * from "./zPayCreditCard.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=31b36a7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports